module.exports = __webpack_public_path__ + "img/technology.799d5d1.webp";